import React, { useContext } from 'react';
import { CallCenterStore } from './callCenterStore';
import { LiveOrdersStore } from './liveOrdersStore';

interface LiveOrdersContextType {
  store: LiveOrdersStore;
}

export const LiveOrdersContext = React.createContext<null | LiveOrdersContextType>(null);

export const useLiveOrdersContext = () => {
  const context = useContext(LiveOrdersContext);
  return context as LiveOrdersContextType;
};

interface CallCenterContextType {
  store: CallCenterStore;
}

export const CallCenterContext = React.createContext<null | CallCenterContextType>(null);

export const useCallCenterContext = () => {
  const context = useContext(CallCenterContext);
  return context as CallCenterContextType;
};
